import { MaintenanceHistoryContext } from 'app/components/ReactContexts/maintenanceHistoryContext';
import { useContext, useMemo } from 'react';
import { MaintenanceNextIntervalsFactory } from 'services/maintenance-tracking';
import { getMaintenanceIntervals } from 'services/maintenance-tracking';

export default function useMaintenanceNextIntervals(engineHours: number) {
  const { maintenanceHistoryData } = useContext(MaintenanceHistoryContext);

  const { selectedEquipmentMaintenanceHistory, rawMaintenanceIntervals } =
    maintenanceHistoryData;

  const intervals = useMemo(() => {
    const intervals = getMaintenanceIntervals(rawMaintenanceIntervals);
    const factory = new MaintenanceNextIntervalsFactory(
      engineHours,
      intervals,
      selectedEquipmentMaintenanceHistory,
    );

    return factory.getIntervals();
  }, [
    engineHours,
    selectedEquipmentMaintenanceHistory,
    rawMaintenanceIntervals,
  ]);

  return intervals;
}
